import { render, staticRenderFns } from "./NotificationsManager.vue?vue&type=template&id=db842694&scoped=true"
import script from "./NotificationsManager.vue?vue&type=script&lang=js"
export * from "./NotificationsManager.vue?vue&type=script&lang=js"
import style0 from "./NotificationsManager.vue?vue&type=style&index=0&id=db842694&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db842694",
  null
  
)

export default component.exports